import { HookError } from 'components/ErrorBoundary';
import { AuthenticationStateType, AuthenticationReducerActionType } from './types';
import { ACTIONS } from 'constants/hook';

export const initialState: AuthenticationStateType = {
  browserCookieId: '',
  carvanaDeviceId: null, // only exists for iOS webview
  propel: {
    twilioAccessToken: '',
    mojoAccessToken: '',
    conversationId: '',
    userProfileId: '',
  },
  unixTimeAppLoaded: Date.now(),
  unixTimeLastInitialization: undefined,
  user: null, // only exists if user is logged in
  userIdentifierType: '',
};

export const authenticationReducer = (
  state: AuthenticationStateType,
  action: AuthenticationReducerActionType,
) => {
  switch (action.type) {
    case ACTIONS.INITIALIZE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case ACTIONS.CHANGE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case ACTIONS.RESET: {
      return initialState;
    }
    default: {
      throw new HookError(`Unhandled action type: ${action.type}`);
    }
  }
};
